import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import DoctorProfile from './pages/DoctorProfile';
import ServiceDetail from './pages/ServiceDetail/ServiceDetail';
import FacilityDetail from './pages/FacilityDetail';
import ReviewPage from './pages/ReviewPage';
import BookAppointment from './pages/BookAppointment';

import AdminContact from './admin/admincontact';
import UserManagement from './admin/usermanagement';
import VideoManagement from './admin/VideoManagement';
import TeamManagement from './admin/TeamManagement';
import TeamDetails from './admin/TeamDetails';
import ReviewManagement from './admin/ReviewManagement';
import AnalyticsDashboard from './admin/AnalyticsDashboard';
import UserAnalyticsDetail from './admin/UserAnalyticsDetail';
import GalleryManagement from './admin/GalleryManagement';
import FounderManagement from './admin/FounderManagement';
import Login from './admin/auth/login';
import Gallery from './pages/Gallery';

import FloatingReviewButton from './components/FloatingReviewButton';

import analyticsTracker from './utils/analyticsTracker';
analyticsTracker.init();

const isAuthenticated = () =>
  localStorage.getItem('isAdminAuthenticated') === 'true';

const isSuperAdmin = () =>
  localStorage.getItem('userRole') === 'Superadmin';

const ProtectedRoute = ({ element, superAdminOnly = false }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  if (superAdminOnly && !isSuperAdmin()) {
    return <Navigate to="/admin" replace />;
  }
  return element;
};

const LoginRoute = () => {
  if (isAuthenticated()) {
    return <Navigate to="/admin" replace />;
  }
  return <Login />;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<DoctorProfile />} />
        <Route path="/team/:id" element={<DoctorProfile />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/facility/:slug" element={<FacilityDetail />} />
        <Route path="/leave-review" element={<ReviewPage />} />
        <Route path="/book-appointment" element={<BookAppointment />} />
        <Route path="/gallery" element={<Gallery />} />

        <Route path="/admin/login" element={<LoginRoute />} />

        <Route path="/admin" element={<ProtectedRoute element={<AdminContact />} />} />
        <Route path="/admin/reviews" element={<ProtectedRoute element={<ReviewManagement />} />} />
        <Route path="/admin/gallery" element={<ProtectedRoute element={<GalleryManagement />} />} />
        <Route path="/admin/founder" element={<ProtectedRoute element={<FounderManagement />} />} />
        <Route path="/admin/analytics" element={<ProtectedRoute element={<AnalyticsDashboard />} />} />
        <Route path="/admin/analytics/user/:sessionId" element={<ProtectedRoute element={<UserAnalyticsDetail />} />} />
        <Route path="/admin/video" element={<ProtectedRoute element={<VideoManagement />} />} />
        <Route path="/admin/team" element={<ProtectedRoute element={<TeamManagement />} />} />
        <Route path="/admin/team-details" element={<ProtectedRoute element={<TeamDetails />} />} />

        <Route path="/admin/users" element={<ProtectedRoute element={<UserManagement />} superAdminOnly />} />

        <Route path="/admin/*" element={<Navigate to="/admin" replace />} />

      </Routes>
      <FloatingReviewButton />
    </Router>
  );
}

export default App;